import { BetterComboBoxItemFilterFunction } from "../utils/ComboBoxFilterUtil";
import ManyOptionsComboBox from "./ManyOptionsComboBox";

/**
 * Implements "Contains" filtering, including additional text for items
 * @namespace akademika.akamont.customControls
 */
export default class ComboBoxBetterFilter extends ManyOptionsComboBox {
  init(): void {
    super.init.apply(this);

    this.setFilterFunction(BetterComboBoxItemFilterFunction);
  }

  static renderer = { apiVersion: 2 };
}
